export const formatNumber = (number) => {
  return new Intl.NumberFormat('id-ID').format(number)
}

export const newFormatThousandSeparator = (
  amount,
  maxFractionDigits = 2,
  locale = 'id-ID',
) => {
  return new Intl.NumberFormat(locale, {
    useGrouping: 'always',
    minimumFractionDigits: 0,
    maximumFractionDigits: maxFractionDigits,
  }).format(amount ?? 0)
}

export const parseNumberFromString = (value) => {
  if (typeof value === 'number') return value
  if (!value) return 0
  const stringValue = String(value).replace(/\./g, '').replace(/,/g, '.')
  return parseFloat(stringValue) || 0
}
